<template>
  <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="52" height="52" rx="12" fill="white" />
    <path
      d="M31.25 15.5C33.3567 15.5 34.41 15.5 35.1667 16.0056C35.4943 16.2245 35.7755 16.5057 35.9944 16.8333C36.5 17.59 36.5 18.6433 36.5 20.75V35C36.5 37.8284 36.5 39.2426 35.6213 40.1213C34.7426 41 33.3284 41 30.5 41H21.5C18.6716 41 17.2574 41 16.3787 40.1213C15.5 39.2426 15.5 37.8284 15.5 35V20.75C15.5 18.6433 15.5 17.59 16.0056 16.8333C16.2245 16.5057 16.5057 16.2245 16.8333 16.0056C17.59 15.5 18.6433 15.5 20.75 15.5"
      stroke="url(#paint0_linear_37_1624)"
      stroke-width="2.5"
    />
    <path
      d="M21.5 15.5C21.5 13.8431 22.8431 12.5 24.5 12.5H27.5C29.1569 12.5 30.5 13.8431 30.5 15.5C30.5 17.1569 29.1569 18.5 27.5 18.5H24.5C22.8431 18.5 21.5 17.1569 21.5 15.5Z"
      stroke="url(#paint1_linear_37_1624)"
      stroke-width="2.5"
    />
    <path
      d="M21.5 26L30.5 26"
      stroke="url(#paint2_linear_37_1624)"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M21.5 32L27.5 32"
      stroke="url(#paint3_linear_37_1624)"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_37_1624"
        x1="15.5"
        y1="15.5"
        x2="40.5791"
        y2="36.0129"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_37_1624"
        x1="21.5"
        y1="12.5"
        x2="27.0719"
        y2="20.801"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_37_1624"
        x1="21.5"
        y1="26"
        x2="21.7217"
        y2="27.982"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_37_1624"
        x1="21.5"
        y1="32"
        x2="21.8275"
        y2="33.9519"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
    </defs>
  </svg>
</template>
